export default __webpack_public_path__ + "static/gdpr-719cb387b68bcf72d278108c037b7fb3.png";